module.exports = __webpack_public_path__ + "static/img/logo.839b696f.png";